import TranslationSettings from '../store/schema/TranslationSettings';
import { makeGetRequest } from 'owa-ows-gateway';

export const CLOUD_SETTINGS_BASE_URL = '/ows/v1/OutlookCloudSettings/settings/account';
export const TRANSLATION_MODE_SETTING_NAME = 'translator_translation_mode';
export const TARGET_LANGUAGE_SETTING_NAME = 'translator_target_language';
export const EXCLUDED_LANGUAGES_SETTING_NAME = 'translator_known_languages';

let loadPromise: Promise<TranslationSettings>;

export default async function loadOcsTranslationSettings() {
    if (!loadPromise) {
        loadPromise = makeGetRequest(
            `${CLOUD_SETTINGS_BASE_URL}?settingname=
            ${TRANSLATION_MODE_SETTING_NAME},
            ${TARGET_LANGUAGE_SETTING_NAME},
            ${EXCLUDED_LANGUAGES_SETTING_NAME}`,
            null /* correlationId */,
            false /* returnFullResponse */,
            null /* customHeaders */,
            true /* throwSeriveError */
        )
            .then(settingResponse => {
                const settings: TranslationSettings = {
                    translationMode: null,
                    targetLanguage: null,
                    excludedLanguages: null,
                    initialized: false,
                };

                settingResponse.forEach(response => {
                    switch (response.name) {
                        case TRANSLATION_MODE_SETTING_NAME:
                            settings.translationMode = parseInt(response.value, 10);
                            break;
                        case TARGET_LANGUAGE_SETTING_NAME:
                            settings.targetLanguage = response.value;
                            break;
                        case EXCLUDED_LANGUAGES_SETTING_NAME:
                            const parsedValue = JSON.parse(response.value);
                            settings.excludedLanguages = [];
                            parsedValue.forEach(lang =>
                                settings.excludedLanguages.push(lang.languageTag)
                            );
                            break;
                    }
                });
                return settings;
            })
            .catch(ex => {
                loadPromise = null;
                throw ex;
            });
    }
    return loadPromise;
}
